export enum BreakpointName {
    XSMALL = 'xsmall',
    SMALL = 'small',
    MEDIUM = 'medium',
    LARGE = 'large',
    XLARGE = 'xlarge',
    MAX = 'max'
}

type BreakpointValues = Record<BreakpointName, number>;

// Must stay in descending order
const value: BreakpointValues = {
    [BreakpointName.MAX]: 1600,
    [BreakpointName.XLARGE]: 1280,
    [BreakpointName.LARGE]: 1024,
    [BreakpointName.MEDIUM]: 768,
    [BreakpointName.SMALL]: 576,
    [BreakpointName.XSMALL]: 0
};

export default {
    name: BreakpointName,
    value
};
